import { render, staticRenderFns } from "./ImageSelection.vue?vue&type=template&id=dc7ca6a2&scoped=true"
import script from "./ImageSelection.vue?vue&type=script&lang=js"
export * from "./ImageSelection.vue?vue&type=script&lang=js"
import style0 from "./ImageSelection.vue?vue&type=style&index=0&id=dc7ca6a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7ca6a2",
  null
  
)

export default component.exports